<template>
  <v-container>
    <h1>Egresos</h1>
    <v-row class="ma-0">
      <v-col cols="12" md="12" class="d-flex my-2 justify-end py-0 px-0">
        <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
          <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
            <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
          </div>
          <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ "Total currency gain: " }}</div>
          <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}">
            {{ " $" + formatMoney(totalProfit) + " " + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN') }}
          </span>
        </div>
      </v-col>
      <v-col class="pa-0 my-4" cols="3">
        <v-autocomplete
          :label="'Selecciona un beneficiario'"
          :items="paymentsRecipients"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          clearable
          color="black"
          item-value="sPaymentRecipientId"
          item-text="sName"
          @change="getEgresos()"
          v-model="selectedSupplier"
        ></v-autocomplete>
      </v-col>
      <v-col class="pa-0 my-4">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar"
          clearable
          hide-details
          outlined
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4 gap-2">
        <v-btn
          color="black"
          elevation="8"
          class="white--text ml-4"
          style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;"
          :disabled="selectedPayments.length === 0"
          :loading="isDownloadingZip"
          @click="downloadSelectedAsZip()"
        >
          <v-icon left>mdi-folder-zip-outline</v-icon>
          {{ "Descargar comprobantes" + (selectedPayments.length > 0 ? ' (' + selectedPayments.length + ')' : '') }}
        </v-btn>
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="payments" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">
              <v-simple-checkbox
                :value="allSelected"
                :indeterminate="someSelected && !allSelected"
                @input="toggleSelectAll()"
                color="black"
              ></v-simple-checkbox>
            </th>
            <th class="header__title center">{{ "Id" }}</th>
            <th class="header__title center">{{ "Fecha de pago" }}</th>
            <th class="header__title center">{{ "Destinatario" }}</th>
            <th class="header__title center">{{ "Status" }}</th>
            <th class="header__title center">{{ "Tipo de cambio" }}</th>
            <th class="header__title center">{{ "Monto origen" }}</th>
            <th class="header__title center">{{ "Monto destino" }}</th>
            <th class="header__title center">{{ "Monto aplicado" }}</th>
            <th class="header__title center">{{ "Facturas" }}</th>
            <th class="header__title center">{{ "Currency gain" }}</th>
            <th class="header__title center">{{ "Profit (%)" }}</th>
            <th class="header__title right">{{ "Actions" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">
              <v-simple-checkbox
                :value="isSelected(item)"
                :disabled="!isSelected(item) && selectionLimitReached"
                @input="toggleSelection(item)"
                color="black"
              ></v-simple-checkbox>
            </td>
            <td class="table__item">{{ item.sPaymentId }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">{{ item.PaymentRecipient}}</td>
            <td class="table__item">
              <v-chip :color="setStatusColor(item.StatusPayments)" class="ma-2" outlined>
                {{ item.StatusPayments }}
              </v-chip>
            </td>
            <td class="table__item">{{  item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-" }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dPaymentAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dDescAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item" :style="item.montoAplicado == item.dDescAmount ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ "$ " + formatMoney(item.montoAplicado) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" style="text-overflow: ellipsis; max-width: 100px; overflow: hidden;">
                    {{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}
                  </div>
                </template>
                <span>{{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}</span>
              </v-tooltip>
            </td>
            <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</td>
            <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Modificar status</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="getReceipt(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-invoice-text-outline</v-icon>
                  </v-btn>
                </template>
                <span>Descargar comprobante</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="getCep(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-receipt-text</v-icon>
                  </v-btn>
                </template>
                <span>Descargar cep</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- Tabla mobile -->
    <v-data-table class="d-sm-none d-block" hide-default-header :items="payments" style="background-color: white !important">
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
            <td class="table__item__mobile">
              <div>{{ "Id" }}</div>
              <div>{{ item.sPaymentId }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Fecha de pago" }}</div>
              <div>{{ formatDate(item.created_at) }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Destinatario" }}</div>
              <div>{{ item.PaymentRecipient }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Status" }}</div>
              <div>
                <v-chip :color="setStatusColor(item.StatusPayments)" class="ma-2" outlined>
                  {{ item.StatusPayments }}
                </v-chip>
              </div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Tipo de cambio" }}</div>
              <div>{{ item.dRate ? "$ " + formatMoney(item.dRate) + " MXN" : "-" }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Monto origen" }}</div>
              <div>{{ "$ " + formatMoney(item.dPaymentAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Monto destino" }}</div>
              <div>{{ "$ " + formatMoney(item.dDescAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Monto aplicado" }}</div>
              <div :style="item.montoAplicado == item.dDescAmount ? 'color: #4CAF50;' : 'color: #E74C3C;'">{{ "$ " + formatMoney(item.montoAplicado) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Facturas" }}</div>
              <div>{{ item.invoices && item.invoices.length ? item.invoices.join(', ') : '-' }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Currency gain" }}</div>
              <div :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Profit (%)" }}</div>
              <div :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</div>
            </td>
            <td class="table__item__mobile">
              <div>{{ "Acciones" }}</div>
              <div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Detalle</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Modificar status</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getReceipt(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-invoice-text-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar comprobante</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getCep(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-receipt-text</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar cep</span>
                </v-tooltip>
              </div>
            </td>
            <v-divider></v-divider>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- Snackbar de progreso ZIP -->
    <v-snackbar v-model="showZipProgress" bottom :timeout="-1" color="black">
      <div class="d-flex align-center">
        <v-progress-circular
          :value="zipProgressPercent"
          size="32"
          width="3"
          color="white"
          class="mr-3"
        >
          <span style="font-size: 9px; color: white;">{{ zipProgressPercent }}%</span>
        </v-progress-circular>
        <span style="font-family: 'montserrat-medium';">
          {{ "Descargando " + zipProgressCurrent + " de " + zipProgressTotal + " archivos..." }}
        </span>
      </div>
    </v-snackbar>
    <PaymentDetailDialog v-model="dialogPaymentDetail" :s-payment-id="selectedPaymentId" />
  </v-container>
</template>
<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";
  import PaymentDetailDialog from "@/components/dialogs/PaymentDetailDialog.vue";

  export default {
    name: "Egresos",
    components: {
      PaymentDetailDialog,
    },
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        paymentsRaw: [],
        totalProfit: 0,
        busqueda: "",
        isLoading: true,
        dialogRequestPayment: false,
        dialogPaymentDetail: false,
        selectedPaymentId: null,
        forward: null,
        paymentsRecipients: [],
        selectedSupplier: null,
        isLoadingSuppliers: false,
        selectedPayments: [],
        isDownloadingZip: false,
        showZipProgress: false,
        zipProgressCurrent: 0,
        zipProgressTotal: 0,
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'egresos') {
          this.getSuppliers();
          this.getEgresos();
        }
      }
    },
    computed: {
      payments() {
        if (!this.busqueda) return this.paymentsRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.paymentsRaw.filter((item) => {
          const formattedRate = item.dRate ? `$ ${this.formatMoney(item.dRate)} MXN` : '-';
          const formattedPaymentAmount = `$ ${this.formatMoney(item.dPaymentAmount)} ${item.sCurrency || 'USD'}`;
          const formattedDescAmount = `$ ${this.formatMoney(item.dDescAmount)} ${item.sDestCurrency || 'MXN'}`;
          const formattedDate = this.formatDate(item.created_at);
          const invoices = item.invoices && item.invoices.length ? item.invoices.join(', ') : '-';

          return (
            String(item.iTrackingId).toLowerCase().includes(filtro) ||
            formattedDate.toLowerCase().includes(filtro) ||
            item.PaymentRecipient?.toLowerCase().includes(filtro) ||
            item.StatusPayments?.toLowerCase().includes(filtro) ||
            formattedRate.toLowerCase().includes(filtro) ||
            formattedPaymentAmount.toLowerCase().includes(filtro) ||
            formattedDescAmount.toLowerCase().includes(filtro) ||
            invoices.toLowerCase().includes(filtro)
          );
        });
      },
      allSelected() {
        const visibleItems = this.payments.slice(0, 20);
        return visibleItems.length > 0 && visibleItems.every(item => this.isSelected(item));
      },
      someSelected() {
        return this.selectedPayments.length > 0;
      },
      zipProgressPercent() {
        if (this.zipProgressTotal === 0) return 0;
        return Math.round((this.zipProgressCurrent / this.zipProgressTotal) * 100);
      },
      selectionLimitReached() {
        return this.selectedPayments.length >= 20;
      },
    },
    mounted() {
      if (this.activeTab === 'egresos') {
        this.getSuppliers();
        this.getEgresos();
      }
    },
    methods: {
      isSelected(item) {
        return this.selectedPayments.some(p => p.sPaymentId === item.sPaymentId);
      },
      toggleSelection(item) {
        if (this.isSelected(item)) {
          this.selectedPayments = this.selectedPayments.filter(p => p.sPaymentId !== item.sPaymentId);
        } else {
          if (this.selectionLimitReached) {
            this.mixWarning("Solo puedes seleccionar máximo 20 egresos a la vez.");
            return;
          }
          this.selectedPayments.push(item);
        }
      },
      toggleSelectAll() {
        if (this.allSelected) {
          this.selectedPayments = [];
        } else {
          const visibleItems = this.payments.slice(0, 20);
          this.selectedPayments = [...visibleItems];
        }
      },
      async downloadSelectedAsZip() {
        if (this.selectedPayments.length === 0) return;

        this.isDownloadingZip = true;
        this.zipProgressCurrent = 0;
        this.zipProgressTotal = this.selectedPayments.length;
        this.showZipProgress = true;

        try {
          const payload = {
            aPaymentIds: this.selectedPayments.map(p => p.sPaymentId),
            sEnterpriseId: this.$route.params.sEnterpriseId,
          };

          const response = await DB.post(
            `${URI}/api/v1/en/administrator/getReceiptsZip`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              },
              responseType: 'blob',
              timeout: 5 * 60 * 1000
            }
          );

          const successCount = parseInt(response.headers['x-receipts-success'] || '0');
          const errorsCount = parseInt(response.headers['x-receipts-errors'] || '0');
          const total = parseInt(response.headers['x-receipts-total'] || '0');

          this.zipProgressCurrent = total;

          const timestamp = moment().format('YYYYMMDD_HHmmss');
          saveAs(response.data, `Comprobantes_Egresos_${timestamp}.zip`);

          await new Promise(resolve => setTimeout(resolve, 1000));
          this.showZipProgress = false;
          await this.$nextTick();

          if (errorsCount > 0) {
            this.mixWarning(`ZIP generado con ${successCount} de ${total} comprobantes. ${errorsCount} fallaron.`);
          } else {
            this.mixSuccess(`${successCount} comprobante(s) descargados correctamente.`);
          }
        } catch (error) {
          this.showZipProgress = false;
          this.mixError("Error al descargar los comprobantes.", error?.response?.status || 500);
        }

        this.selectedPayments = [];
        this.isDownloadingZip = false;
        this.zipProgressCurrent = 0;
        this.zipProgressTotal = 0;
      },
      getEgresos() {
        this.isLoading = true;
        this.paymentsRaw = [];
        this.totalProfit = 0;
        this.selectedPayments = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sPaymentRecipientId: this.selectedSupplier,
        };

        DB.post(`${URI}/api/v1/en/administrator/payments`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.paymentsRaw = response.data.payments;
          this.paymentsRaw.forEach((payment) => {
            this.totalProfit += parseFloat(payment.dCurrencyGain);
          });
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      getSuppliers() {
        this.isLoadingSuppliers = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/suppliers`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.isLoadingSuppliers = false;
          this.paymentsRecipients = response.data.paymentRecipients;
        })
        .catch((error) => {
          this.isLoadingSuppliers = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      openDetail(item) {
        this.selectedPaymentId = item.sPaymentId;
        this.dialogPaymentDetail = true;
      },
      getReceipt(item) {
        this.loading = true;
        const payload = {
          sPaymentId: item.sPaymentId,
          sEnterpriseId: item.sEnterpriseId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/getReceipt`, payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            },
            responseType: 'blob'
          }
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${item.PaymentRecipient + (item.invoice ? "_" + item.invoice : "")}.pdf`;
          link.click();
        })
        .catch((error) => {
          this.mixError(
            error?.response?.data?.message || "No se pudo descargar el archivo",
            error?.response?.status || 500
          );
        })
        .finally(() => {
          this.loading = false;
        });
      },
      getCep(item) {
        this.loading = true;
        const payload = {
          sPaymentId: item.sPaymentId,
          sEnterpriseId: item.sEnterpriseId,
        };

        DB.post(
          `${URI}/api/v1/en/administrator/getCep`, payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
        .then((response) => {
          const url = response.data.paymentCep;
          if (url) {
            window.open(url, "_blank");
          } else {
            this.mixError("Error al descargar el cep.", 400);
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate(date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      setStatusColor(status) {
        if (status === "COMPLETED" || status === "DEPOSITED") {
          return "green";
        } else if(status === "PENDING_TO_PROCESS"){
          return "blue";
        } else if(status === "PENDING_TO_DEPOSIT"){
          return "blue";
        } else if(status === "REJECTED"){
          return "red";
        }
        else {
          return "gray";
        }
      },
      dataXLSX() {
        try {
          const data = this.paymentsRaw.map((item) => ({
            "ID de seguimiento": item.sPaymentId || "-",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "-",
            Beneficiario: item.PaymentRecipient || "-",
            Estatus: item.StatusPayments || "-",
            "Tipo de cambio": item.dRate ? `${this.formatMoney(item.dRate)}` : "-",
            "Monto original": `${this.formatMoney(item.dPaymentAmount)}`,
            "Monto convertido": `${this.formatMoney(item.dDescAmount)}`,
            "Currency Origen": item.sCurrency || 'USD',
            "Currency Destino": item.sDestCurrency || 'MXN'
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Egresos");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Egresos.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando egresos";
        } catch (error) {
          console.log(error);
          this.error = true;
          this.codeError = "XLSX_EXPENSES_FAILED";
        }
      }
    },
  };
</script>
<style scoped>
</style>
